import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketsRoutingModule } from './markets-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DfSelectModule } from '@design-factory/design-factory';
import { ComponentsModule } from '../components/components.module';
import { PointsOfSaleModule } from '../points-of-sale/points-of-sale.module';
import { AgGridModule } from 'ag-grid-angular';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    MarketsRoutingModule,
    ComponentsModule,
    DfSelectModule,
    PointsOfSaleModule,
    AgGridModule
  ]
})
export class MarketsModule {}
